import type { Schemas } from "@/shared/api/client";

/** The part of the day the server greets for, in the agency's time zone. */
export type Greeting = Schemas["DashboardOut"]["greeting"];

/** "Sara" from "Sara Adel", "سارة" from "سارة عادل": greetings use the first name only. */
export function firstNameOf(name: string): string {
  return name.trim().split(/\s+/)[0] ?? "";
}

const AFTERNOON_FROM_HOUR = 12;
const EVENING_FROM_HOUR = 17;

/** The greeting for a local time, used until the server's (the agency's clock) arrives. */
export function greetingAt(now: Date): Greeting {
  const hour = now.getHours();
  if (hour < AFTERNOON_FROM_HOUR) return "morning";
  return hour < EVENING_FROM_HOUR ? "afternoon" : "evening";
}
